// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import MobileDrawerController from "./mobile_drawer_controller"
application.register("mobile-drawer", MobileDrawerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalManagerController from "./modal_manager_controller"
application.register("modal-manager", ModalManagerController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)
